import PropTypes from 'prop-types';
import React from 'react';
import { motion } from 'framer-motion';
// material
import {
  Box,
  Grid,
  Container,
  Typography,
  Slide,
  Stack,
  TextField,
  Button,
  Divider
} from '@mui/material';
import { Icon } from '@iconify/react';
import { alpha, useTheme } from '@mui/material/styles';
import { toast } from 'react-hot-toast';
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
// components
import arrowBackFilled from '@iconify/icons-eva/arrow-back-fill';
import Page from '../components/Page';
import * as myLayananService from '../services/mylayanan';
import ServicesDetail from '../components/_dashboard/services/ServicesDetail';
import useQuery from '../hooks/useQuery';

// ----------------------------------------------------------------------

ServicesDetailPage.propTypes = {
  user: PropTypes.object.isRequired
};

export default function ServicesDetailPage({ user }) {
  const [layanan, setLayanan] = React.useState({});
  const { id } = useParams();
  const query = useQuery();
  const navigateBack = query.get('navigateBack');
  const prevIdRef = React.useRef(null);
  const isFetchingRef = React.useRef(false);

  // GET LAYANAN DETAIL
  const getLayanan = React.useCallback(async () => {
    if (!id) return;
    // Prevent multiple simultaneous calls
    if (isFetchingRef.current) return;
    // Prevent calling if id hasn't changed
    if (prevIdRef.current === id) return;

    isFetchingRef.current = true;
    prevIdRef.current = id;

    try {
      const result = await myLayananService.getLayananByID(id);
      if (result.data) {
        setLayanan(result.data);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      isFetchingRef.current = false;
    }
  }, [id]);

  React.useEffect(() => {
    getLayanan();
  }, [getLayanan]);
  // END GET LAYANAN DETAIL

  const theme = useTheme();
  const navigate = useNavigate();

  const generateKeterangan = (item) => {
    // let info = '';
    let kategoriPermohonan = '';
    let tipePermohonan = '';

    if (item?.meta?.data_permohonan?.metadata?.tipe_permohonan === 'archive') {
      tipePermohonan = 'Existing';
    } else if (item?.meta?.data_permohonan?.metadata?.tipe_permohonan === 'new_rekomendasi') {
      tipePermohonan = 'Baru';
    }

    if (item?.meta?.data_permohonan?.metadata?.kategori_permohonan === 'hardware') {
      kategoriPermohonan = 'Hardware';
    } else if (item?.meta?.data_permohonan?.metadata?.kategori_permohonan === 'software') {
      kategoriPermohonan = 'Software';
    }

    const permohonanText =
      tipePermohonan && kategoriPermohonan
        ? `${tipePermohonan}/${kategoriPermohonan}`
        : tipePermohonan || kategoriPermohonan;

    if (item.type === 'rekomendasi') {
      return `${item?.meta?.data_permohonan?.metadata?.rekomendasi?.name} (${
        permohonanText || 'Baru'
      })`;
    }

    if (item.type === 'subdomain') {
      return `${item?.meta?.data_permohonan?.metadata?.subdomain} (${permohonanText || 'Baru'})`;
    }

    // if (item?.meta?.data_permohonan?.metadata?.tipe_permohonan === 'archive') info = ' (Existing)';

    // if (item.type === 'rekomendasi')
    //   return `${item?.meta?.data_permohonan?.metadata?.rekomendasi?.name} ${info || ' (Baru)'}`;

    // if (item.type === 'subdomain')
    //   return `${item?.meta?.data_permohonan?.metadata?.hosting?.value} ${info || ' (Baru)'}`;

    if (item.type === 'tte') return `TTE ${item?.meta?.data_permohonan?.metadata?.tte?.name}`;

    if (item.type === 'email') return `Email ${item?.meta?.data_permohonan?.metadata?.email?.name}`;
    // if (item.type === 'email') {
    //   const emailData = item?.meta?.data_permohonan?.metadata?.email;
    //   console.log('Email data:', emailData);
    //   return `Email ${emailData?.name}`;
    // }

    if (item.type === 'aduan') return `Aduan ${item?.meta?.data_permohonan?.metadata?.aduan?.name}`;

    if (item.type === 'videotron')
      return `Videotron ${item?.meta?.data_permohonan?.metadata?.videotron?.name}`;

    if (item.type === 'splp') return `SPLP ${item?.meta?.data_permohonan?.metadata?.splp?.name}`;

    if (item.type === 'cloud') return `Cloud ${item?.meta?.data_permohonan?.metadata?.cloud?.name}`;

    if (item.type === 'backup')
      return `Backup ${item?.meta?.data_permohonan?.metadata?.backup?.name}`;

    if (item.type === 'vpn') return `VPN ${item?.meta?.data_permohonan?.metadata?.vpn?.name}`;

    if (item.type === 'web')
      return `Template Website ${item?.meta?.data_permohonan?.metadata?.web?.name}`;

    return '';
  };
  return (
    <Page title="Dashboard | Layanan">
      <Container maxWidth="xl">
        <Box sx={{ pb: 5 }}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Icon
              cursor="pointer"
              onClick={() => (navigateBack === 'uat' ? navigate('/dashboard/uat') : navigate(-1))}
              icon={arrowBackFilled}
              width={32}
              height={32}
              style={{ color: theme.palette.primary.main }}
            />

            <Typography variant="h4">Detail</Typography>
            <Divider orientation="vertical" flexItem />
            <Typography variant="h4">{generateKeterangan(layanan)}</Typography>
          </Stack>
        </Box>

        {!_.isEmpty(layanan) && (
          <ServicesDetail user={user} layanan={layanan} getLayanan={getLayanan} />
        )}

        {/* {!_.isEmpty(layanan) && layanan.type === 'subdomain' && (
          <ServicesDetailSubdomain layanan={layanan} />
        )}
        {!_.isEmpty(layanan) && layanan.type === 'hosting' && (
          <ServicesDetailHosting layanan={layanan} />
        )} */}
      </Container>
    </Page>
  );
}
